// removed by extract-text-webpack-plugin
module.exports = {"CustomLegend":"CustomLegend__CustomLegend__i8kiS","Li":"CustomLegend__Li__32FBQ","Green":"CustomLegend__Green__wVMZU","Yellow":"CustomLegend__Yellow__hcoYQ","Orange":"CustomLegend__Orange__wGWnc","Red":"CustomLegend__Red__qjG-0"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/CustomLegend/CustomLegend.css
// module id = 267
// module chunks = 0